import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
  const formFieldMinWidth = 150;

  return createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: formFieldMinWidth
    },
    justifyRight: {
      justifyContent: 'flex-end'
    },
    amountInput: {
      minWidth: 80,
      maxWidth: 100
    },
    diagInput: {
      minWidth: 100,
      maxWidth: 120
    },
    tableRowArrowCell: {
      paddingBottom: 0,
      paddingTop: 0
    },
    maxWidthField: {
      minWidth: formFieldMinWidth
    }
  });
});
